import { ITaskProgress } from './taskprogress.models';

export const getExecutionHealth = (row: ITaskProgress) => {
  const physical = Number(row.apr || row.rpr || 0);
  const financial = Number(row.fpr || 0);
  const variance = financial - physical;

  if (Math.abs(variance) <= 10) {
    return { label: '🟢 Aligned', severity: 'success', variance, physical, financial };
  }

  if (Math.abs(variance) >= 30) {
    return { label: '🔴 High Variance', severity: 'error', variance, physical, financial };
  }

  if (variance > 10) {
    return { label: '🟠 Financial Ahead', severity: 'warning', variance, physical, financial };
  }

  return { label: '🟡 Progress Ahead', severity: 'warning', variance, physical, financial };
};

export const getNextAction = (row: ITaskProgress) => {
  if (!row.rid) {
    return {
      label: 'Start Progress',
      actioncode: 'SAVE_PROGRESS',
      tab: 1,
      mode: 'primary',
    };
  }

  switch ((row.ssc || '').toUpperCase()) {
    case 'DRAFT':
      return {
        label: 'Submit for Validation',
        actioncode: 'SUBMIT_PROGRESS',
        tostateid: 2,
        tab: 3,
        mode: 'primary',
      };

    case 'SUBMITTED':
    case 'UNDER_REVIEW':
      return {
        label: 'Waiting for Validation',
        actioncode: '',
        tab: 4,
        mode: 'passive',
      };

    case 'RETURNED':
      return {
        label: 'Update Correction',
        actioncode: 'SAVE_PROGRESS',
        tab: 1,
        mode: 'warning',
      };

    case 'APPROVED':
      return {
        label: 'Continue Monitoring',
        actioncode: 'SAVE_PROGRESS',
        tab: 1,
        mode: 'secondary',
      };

    case 'REJECTED':
      return {
        label: 'Review Rejection',
        actioncode: '',
        tab: 4,
        mode: 'warning',
      };

    case 'CLOSED':
      return {
        label: 'View Closed Task',
        actioncode: '',
        tab: 0,
        mode: 'passive',
      };

    default:
      return {
        label: 'View Task',
        actioncode: '',
        tab: 0,
        mode: 'secondary',
      };
  }
};